<template>
  <div class="uv-card">
    <div class="uv-card-body">
      <v-row>
        <v-col md="9" cols="12">
          <ModuleHeader>Paquetes de precio</ModuleHeader>
        </v-col>
        <v-col md="3" cols="12">
          <v-autocomplete
            label="Actividad"
            v-model="rvaDepto"
            @input="getPaquetesPrecio()"
            :items="actividades"
            item-text="nm"
            item-value="id"
          ></v-autocomplete>
        </v-col>
      </v-row>
      <v-alert v-if="!rvaDepto" dense type="info">
        Selecciona una actividad para administrar sus paquetes de precio
      </v-alert>
      <uv-data-table
        v-if="rvaDepto"
        :config="config"
        :data="paquetesPrecio"
        :pageRows="15"
        @buttonClick="dtButtonClick"
      ></uv-data-table>
    </div>
    <modal v-model="showModal" :showFooter="false" title="Paquete de precios">
      <PaquetesPrecioForm
        :edit="editMode"
        :key="formIndex"
        @toggle="toggleModal"
        :dataEdit="editData"
        @successData="successData"
      >
      </PaquetesPrecioForm>
    </modal>
  </div>
</template>

<script>
import uvDataTable from "../../MainComponents/DataTable.vue";
import PaquetesPrecioForm from "./PaquetesPrecioForm.vue";
import axiosCore from "axios";
import { mapGetters } from "vuex";
export default {
  name: "PaquetesPrecioCRUD",
  components: {
    uvDataTable,
    PaquetesPrecioForm,
  },
  props: [],
  data() {
    return {
      actividades:[],
      paquetesPrecio: [],
      rvaDepto: null,
      formIndex: 0,
      editMode: false,
      editData: {},
      showModal: false,
      config: {
        selectableRow: true,
        selectConfig: {
          idRowData: "id", // id necesario para indicar id unico del row que esta seleccionado y retornarlo en los eventos requeridos
        },
        orderByCol: { Field: "", Type: "Asc" },
        buttons: [
          {
            text: "Agregar",
            icon: "lni lni-plus",
            buttonId: "addPaquetePrecio",
          },
          {
            text: "Ver info",
            icon: "lni lni-pencil-alt",
            buttonId: "editarPaquetePrecio",
            require: true,
          },
          {
            text: "Eliminar",
            icon: "lni lni-trash",
            buttonId: "deletePaquetePrecio",
            require: true,
          },
        ],
        fields: [
          {
            text: "Nombre",
            value: "nm",
          },
        ],
      },
      idSelected: "",
    };
  },
  computed: {
    departamentos() {
      let deptos = [];
      let departamentos = this.$store.getters.getDepartamentos;
      departamentos.forEach((dep) => {
        if (dep.id != "Golf") {
          (dep.text = dep.Nombre), (dep.value = dep.id);
          deptos.push(dep);
        }
      });
      return deptos;
    },
  },
  methods: {
    successData(data, doAction) {
      if (doAction == "CREATE") {
        this.createPaquetePrecio(data);
      } else {
        this.updatePaquetePrecio(data);
      }
    },
    dtButtonClick(buttonId, idSelected) {
      this.formIndex++;
      if (buttonId == "addPaquetePrecio") {
        this.idSelected = "";
        this.editMode = false;
        this.editData = {};
        //this.$refs.modalForm.setTitle("Agregar MetodoPago");
        this.toggleModal(true);
      }
      if (buttonId == "editarPaquetePrecio") {
        this.idSelected = idSelected[0];
        const mp = this.$pgsHelper.getById(
          this.paquetesPrecio,
          "id",
          idSelected[0]
        );
        if (mp.Prtgdo) {
          this.$swal(
            "No se puede editar un metodo de pago protegido",
            "",
            "error"
          );
          return false;
        }
        this.editMode = true;
        this.editData = mp;

        this.toggleModal(true);
      }
      if (buttonId == "reportMembresia") {
        this.$router.push({ path: "/membresias/movimientos" });
      }
      if (buttonId == "deletePaquetePrecio") {
        const mp = this.$pgsHelper.getById(
          this.paquetesPrecio,
          "id",
          idSelected[0]
        );
        if (mp.Prtgdo) {
          this.$swal(
            "No se puede editar un metodo de pago protegido",
            "",
            "error"
          );
          return false;
        }
        this.deletePaquetePrecio(idSelected[0]);
      }
    },
    async getPaquetesPrecio() {
      let paquetes = [];
      const snapshot = await this.$store.getters.getFirebaseApp.database.queryBuilder(
        "ACT/Paquetes"
      );
      if (snapshot.val()) {
        let docs = Object.entries(snapshot.val());
        docs.forEach((element) => {
          if (element[1].ia == this.rvaDepto) {
            paquetes.push({ id: element[0], ...element[1] });
          }
        });
      }
      this.paquetesPrecio = paquetes;
    },
    createPaquetePrecio(data) {
      data.ia = this.rvaDepto;
      this.$swal({
        title: "¿Deseas guardar el paquete de precios?",
        text: "",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("ACT-Paquetes-createPaquete", data)
            .then(function(result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          this.$emit("reloadClient");
          if (result.value.data.ok) {
            this.$swal({
              title: "Guardado",
              text: "El paquete se guardo correctamente",
              icon: "success",
            }).then(() => {
              this.toggleModal(false);
              this.getPaquetesPrecio()
            });
          } else {
            this.$swal(
              "Error saving paquete de precio",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
    updatePaquetePrecio(data) {
      this.$swal({
        title: "¿Deseas editar el paquete de precios?",
        text: "",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("GBL-MetodoPago-PaquetePrecio", data)
            .then(function(result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          this.$emit("reloadClient");
          if (result.value.data.ok) {
            this.$swal({
              title: "Guardado",
              text: "El paquete de precios se guardo correctamente",
              icon: "success",
            }).then(() => {
              this.toggleModal(false);
            });
          } else {
            this.$swal(
              "Error saving paquete de precio",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
    deletePaquetePrecio(id) {
      let datos = { Id: id };
      this.$swal({
        title: "¿Deseas eliminar el paquete de precios?",
        text: "Se eliminara permanentemente",
        icon: "warning",
        showCancelButton: true,
        allowOutsideClick: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("ACT-Paquetes-deletePaquete", datos)
            .then(function(result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$swal(
              "El paquete de precios se elimino correctamente",
              "",
              "success"
            );
            //this.getClientes();
            this.getPaquetesPrecio()
            this.$forceUpdate();
          } else {
            this.$swal(
              "Error eliminando datos",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
    toggleModal(open) {
      this.showModal = open;
    },
    async getActividades() {
      let actividades = [];
      const snapshot = await this.$store.getters.getFirebaseApp.database.queryBuilder(
        "ACT/Actividades"
      );
      if (snapshot.val()) {
        let docs = Object.entries(snapshot.val());
        docs.forEach((element) => {
          actividades.push({ id: element[0], ...element[1] });
        });
        this.actividades = actividades;
      }else{
        this.actividades = []
      }
    },
  },
  beforeMount: function() {},
  mounted: async function() {
    this.getActividades();
    this.getPaquetesPrecio();
  },
};
</script>
